/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsMetadataRpc
 */
import * as References from './ApprovalsMetadataRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery } from 'data-fetching-client/next';
export const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsMetadataRpc#listApprovalSettingsAssets
 */
export const LIST_APPROVAL_SETTINGS_ASSETS_QUERY_FIELD_NAME = 'com_hubspot_product_approvals_rpc_ApprovalsMetadataRpc_listApprovalSettingsAssets';
export const LIST_APPROVAL_SETTINGS_ASSETS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: LIST_APPROVAL_SETTINGS_ASSETS_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.listApprovalSettingsAssetsRpc, {
      timeout: ctx.timeout,
      request: {}
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsMetadataRpc#listApprovalTypeOptions
 */
export const LIST_APPROVAL_TYPE_OPTIONS_QUERY_FIELD_NAME = 'com_hubspot_product_approvals_rpc_ApprovalsMetadataRpc_listApprovalTypeOptions';
export const LIST_APPROVAL_TYPE_OPTIONS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: LIST_APPROVAL_TYPE_OPTIONS_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.listApprovalTypeOptionsRpc, {
      timeout: ctx.timeout,
      request: {}
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsMetadataRpc#resolveBreezeAgentNames
 */
export const RESOLVE_BREEZE_AGENT_NAMES_QUERY_FIELD_NAME = 'com_hubspot_product_approvals_rpc_ApprovalsMetadataRpc_resolveBreezeAgentNames';
export const RESOLVE_BREEZE_AGENT_NAMES_QUERY = /* #__PURE__ */registerQuery({
  fieldName: RESOLVE_BREEZE_AGENT_NAMES_QUERY_FIELD_NAME,
  args: ['agentIds'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.resolveBreezeAgentNamesRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});